import React from 'react';
import { useState, useCallback, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { getRolesList } from '../../../util/APIUtils';
import useUnleashHook from '../../core/unleash/useUnleashHook';
import UnleashService from '../../services/unleash/unleash.service';

const INITIAL_PAGE_SIZE = 50;
const DEFAULT_COLUMNS = [
  {
    name: 'roleName',
    displayName: 'Roles',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'totalUsers',
    displayName: 'No of Users',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
    sortByProp: 'name'
  },
  {
    name: 'roleDescription',
    displayName: 'Description',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'locationNames',
    displayName: 'Location',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'active',
    displayName: 'Status',
    sortOrder: 'none',
    isFilterable: true,
    isSortable: true,
    isVisible: true,
    type: 'value',
  },
  {
    name: 'action',
    displayName: 'Action',
    sortOrder: 'none',
    isFilterable: true,
    isVisible: true,
    type: 'override',
  }
];

export const useManageRoleHook = (history) => {
  const [loading, setLoading] = useState(true);
  const [roles, setRoles] = useState([]);

  const shouldShowManageProgramsNewUI = useUnleashHook(UnleashService.FLAGS.SHOW_MANAGE_PROGRAMS_LISTING_NEW_UI).isFlagEnabled();
  const [isNewRoleDialogOpen, setIsNewRoleDialogOpen] = useState(false);

  const handleNewRoleDialogClose = useCallback(() => {
    setIsNewRoleDialogOpen(false);
  }, []);

  const handleNewRoleDialogOpen = useCallback(() => {
    setIsNewRoleDialogOpen(true);
  }, []);

  const getRoles = async () => {
    try {
      setLoading(true);
      const response = await getRolesList();
      setRoles(response || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {   
    getRoles();
  }, []);

  const rolesData = roles?.map(role => ({
    isSelected: false,
    rowData: {
      roleName: role.roleName,
      totalUsers: role.totalUsers,
      roleDescription: role.roleDescription,
      locationNames: role.locationNames,
      active: role.active ? 'Active' : 'Inactive',
      action: () => (
        <Button
          color="primary"
          variant="contained"
          aria-label="Edit Program"
          onClick={() => {
            history.push({
              pathname: `/manageRoles/${encodeURIComponent(role.roleName)}/${role.roleId}`,
              state: { role },
            })
          }}
        >
          View
        </Button>
      )
    },
    styles: {
      roleName: {
        opacity: role.systemDefault ? '0.5' : '' 
      },
      totalUsers: {
        opacity: role.systemDefault ? '0.5' : '' 
      },
      roleDescription: {
        opacity: role.systemDefault ? '0.5' : '' 
      },
      locationNames: {
        opacity: role.systemDefault ? '0.5' : '' 
      }
    }
  }));

  return {
    isNewRoleDialogOpen,
    handleNewRoleDialogOpen,
    handleNewRoleDialogClose,
    columns: DEFAULT_COLUMNS,
    pageSize: INITIAL_PAGE_SIZE,
    rolesData,
    loading,
    refreshRoles: getRoles,
    shouldShowManageProgramsNewUI,
    roles // Expose the roles state
  };
};
